var _desc, _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-294.000000, -34.000000)",
    id: "City"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(294.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,4 L8,2 L3,4 L3,22 L13,22 L13,4 Z M7,20 L5,20 L5,18 L7,18 L7,20 L7,20 Z M7,16 L5,16 L5,14 L7,14 L7,16 L7,16 Z M7,12 L5,12 L5,10 L7,10 L7,12 L7,12 Z M7,8 L5,8 L5,6 L7,6 L7,8 L7,8 Z M11,20 L9,20 L9,18 L11,18 L11,20 L11,20 Z M11,16 L9,16 L9,14 L11,14 L11,16 L11,16 Z M11,12 L9,12 L9,10 L11,10 L11,12 L11,12 Z M11,8 L9,8 L9,6 L11,6 L11,8 Z M21,8 L18,6 L15,8 L15,22 L21,22 L21,8 Z M19,10 L17,10 L17,12 L19,12 L19,10 Z M19,14 L17,14 L17,16 L19,16 L19,14 Z M19,18 L17,18 L17,20 L19,20 L19,18 Z",
    fill: "#212121"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCity);
export default __webpack_public_path__ + "static/media/ic-city.0ad12e71ac58b63630b13007afeb533a.svg";
export { ForwardRef as ReactComponent };